// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3675d40a","703":"f2c3e6fe"}[chunkId] + ".chunk.js";
};